import React, { useState, useEffect } from "react";
import "../../../App.css";
import { toast } from "react-toastify";
import { Modal, Button, Table, Dropdown, Form } from "react-bootstrap";
import axios from "../../../../node_modules/axios/index";
import Loader from "../../Common/Loader";
import LoaderButton from "../../Common/LoaderButton";
import NoDataFound from "../../Common/NoDataFound";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../Common/Alert";
import CustomizedSwitches from "./switch";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import DesignationDropdown from "./DesignationDropdown";
import DepartmentDropdown from "./DepartmentDropdown";
import UnitDropdown from "./UnitDropdown";
import EditDesignationDropdown from "./EditDesignationDropdown";
import EditDepartmentDropdown from "./EditDepartmentDropdown";
import EditUnitDropdown from "./EditUnitDropdown";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Navigate, Link, useLocation } from "react-router-dom";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import constatntMessages from "../../../constants/constatntMessages";
import { fetchIpAddress } from "../../../helpers/commonHelpers";
import * as XLSX from "xlsx";

import { useRef } from "react";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import BackButton from "../../Common/Backbutton";
import download from "../../../../src/assets/images/download.svg";
import upload from "../../../../src/assets/images/upload.svg";
import SmallLoaderButton from "../../Common/SmallLoaderButton";
import { fetchExistingGuest } from "../../../redux/actions/meetingActions/MeetingAction";

const Employee = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));

  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }

  const userId = userData?._id;
  const employeeDatas = useSelector((state) => state?.user);

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (employeeDatas?.userData) {
      if (employeeDatas?.userData?.isAdmin === false) {
        navigate("/page-not-found");
      }
    }
    setFileHintsMessage(constatntMessages.fileHints);
  }, [employeeDatas?.userData]);
  const accessToken = localStorage.getItem("accessToken");
  const organizationId = userData?.organizationId;
  //Create Employee
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [units, setUnits] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    empId: "",
    whatsAppNo: "",
    email: "",
    designationId: "",
    departmentId: "",
    unitId: "",
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  //Editttttt
  const [name, setName] = useState("");
  const [empId, setEmpId] = useState("");
  const [email, setEmail] = useState("");
  const [designationId, setDesignationId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [whatsAppNo, setWhatsAppNo] = useState("");
  const [unitId, setUnitId] = useState("");
  const [isAdmin, setIsAdmin] = useState();
  const [isMeetingOrganiser, setIsMeetingOrganiser] = useState();
  //Edit Guest
  const [designation, setDesignation] = useState("");
  const [department, setDepartment] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [role, setRole] = useState("");
  //List Employee
  const [employees, setEmployees] = useState([]);

  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [order, setOrder] = useState(-1);
  const [isFetching, setIsFetching] = useState(false);
  const [isEmployeeSelected, setIsEmployeeSelected] = useState(true);

  const [employeeData, setEmployeeData] = useState({
    name: "",
    organizationId: organizationId,
    empId: "",
    email: "",
    whatsAppNo: "",
    designationId: "",
    departmentId: "",
    unitId: "",
    isMeetingOrganiser: false,
    isAdmin: false,
    department: "",
    designation: "",
  });

  //DELETE Employee
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);
  //EDIT Employee
  const [showEditModal, setShowEditModal] = useState(false);
  const [editEmployeeData, setEditEmployeeData] = useState({});

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [editIsAdmin, setEditIsAdmin] = useState(employeeData.isAdmin || false);
  const [editIsMeetingOrganiser, setEditIsMeetingOrganiser] = useState(
    employeeData.isMeetingOrganiser || false
  );

  //Viewe Employee
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewEmployee, setViewEmployee] = useState({
    name: "",
    organizationId: organizationId,
    empId: "",
    email: "",
    designationId: "",
    departmentId: "",
    whatsAppNo: "",
    unitId: "",
    isAdmin: false,
    isMeetingOrganiser: false,
    isActive: true,
    department: "",
    designation: "",
    role: "",
    companyName: "",
  });

  //Import Employee
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [fileHintsMessage, setFileHintsMessage] = useState("");
  const isValidate = () => {
    let isValid = true;
    const errors = {};

    // Name Validation
    const excludeHtmlForName = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;

    if (!employeeData.name.trim()) {
      errors.name = "Employee Name is required";
      isValid = false;
    } else if (!excludeHtmlForName.test(employeeData.name)) {
      errors.name = constatntMessages.invalidInputContactPersonName;
      isValid = false;
    } else if (
      employeeData.name.trim().length < 2 ||
      employeeData.name.trim().length > 100
    ) {
      errors.name = "Name must be between 2-100 characters long";
      isValid = false;
    }

    // Employee ID Validation
    const empIdValidation =
      /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

    const trimmedEmpId = employeeData.empId.trim();
    if (!trimmedEmpId) {
      errors.empId = "Employee ID is required";
      isValid = false;
    } else if (!empIdValidation.test(employeeData.empId)) {
      errors.empId = constatntMessages.invalidInput;
      isValid = false;
    } else if (
      employeeData.empId.trim().length < 2 ||
      employeeData.empId.trim().length > 20
    ) {
      errors.empId = "Employee ID must be  2 - 20  characters";
      isValid = false;
    }

    // Email Validation
    const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!employeeData.email.trim()) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!emailValidation.test(employeeData.email)) {
      errors.email = "Please enter a valid email address";
      isValid = false;
    }

    // Designation ID Validation
    if (!employeeData.designationId.trim()) {
      errors.designationId = "Designation is required";
      isValid = false;
    }

    if (!employeeData.departmentId || !employeeData.departmentId.trim()) {
      errors.departmentId = "Department is required";
      isValid = false;
    }

    // Unit ID Validation
    if (!employeeData.unitId.trim()) {
      errors.unitId = "Unit is required";
      isValid = false;
    }

    //whatsAppNo Validation
    // if (!employeeData.whatsAppNo.trim()) {
    //   errors.whatsAppNo = "WhatsApp number is required";
    // }

    // WhatsAppNo Validation
    if (employeeData.whatsAppNo?.trim()) {
      const whatsAppNoTrimmed = employeeData.whatsAppNo.trim();
      const whatsappRegex = /^\d{10}$/;

      if (!whatsappRegex.test(whatsAppNoTrimmed)) {
        errors.whatsAppNo = constatntMessages.whatsAppNo;
        isValid = false;
      }
    }

    setErrors(errors);
    return isValid;
  };
  const handleKeyDown = (e) => {
    const { name, value } = e.target;
    const invalidKeys = ["e", "E", "+", "-", ".", ","];
    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }
    if (name === "whatsAppNo") {
      if (value.length >= 10 && ![8, 37, 39, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
  };

  const handleKeyDownTwo = (e) => {
    // alert("INSDHD")
    const { name, value } = e.target;
    const invalidKeys = ["e", "E", "+", "-", ".", ","];

    if (invalidKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }

    if (name === "whatsAppNo") {
      const isControlKey = [8, 9, 13, 37, 39, 46].includes(e.keyCode);
      if (!/^\d$/.test(e.key) && !isControlKey) {
        e.preventDefault();
        return;
      }

      if (value.length >= 10 && !isControlKey) {
        e.preventDefault();
      }
    }
  };

  //Fetch mod
  const [selectedOption, setSelectedOption] = useState([
    { label: "Select Designations", value: "" },
  ]);
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState([
    { label: "Select Departments", value: "" },
  ]);
  const [selectedUnitOption, setSelectedUnitOption] = useState([
    { label: "Select Unit", value: "" },
  ]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedUnit, SetSelectedUnit] = useState(null);
  const [searchData, setSearchData] = useState({
    unit: "",
    department: "",
    designation: "",
  });
  const fetchMasterData = async () => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/employee/masterData/${organizationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        const { departmentList, designationList, unitList } =
          response.data.data;
        setDepartments(departmentList || []);
        setDesignations(designationList || []);
        setUnits(unitList || []);
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
      if (handleApiError(error)) return;
    }
  };

  useEffect(() => {
    document.title = "Employee: MinutesVault";

    if (!accessToken) {
      navigate("/login");
    }
    setSearchData({});
    setSelectedOption([
      {
        label: employeeData?.designationId,
        value: employeeData?.name,
      },
    ]);
    setSelectedDepartmentOption([
      {
        label: employeeData?.departmentId,
        value: employeeData?.name,
      },
    ]);
    setSelectedUnitOption([
      {
        label: employeeData?.unitId,
        value: employeeData?.name,
      },
    ]);
    setEmployeeData({
      ...employeeData,
      isMeetingOrganiser: employeeData?.isMeetingOrganiser,
      isAdmin: employeeData?.isAdmin,
    });
    if (!authData?.isInValidUser) {
      fetchMasterData();
    }

    const getGuests = async () => {
      try {
        const response = await dispatch(
          fetchExistingGuest(userData.organizationId, accessToken)
        );
      } catch (error) {
        console.error("error fetching guests", error);
      }
    };
    getGuests();
  }, [authData?.isInValidUser]);

  const handleDesignationChange = (e) => {
    setDesignationId(e.value);
  };

  const handleDepartmentChange = (e) => {
    setDepartmentId(e.value);
  };

  const handleUnitChange = (e) => {
    setUnitId(e.value);
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setErrors({});

    const updatedValue =
      name === "email"
        ? value.trim().toLowerCase()
        : type === "checkbox"
          ? checked
          : value;

    if (name === "isMeetingOrganiser" && type === "checkbox") {
      if (checked) {
        setEmployeeData({
          ...employeeData,
          isMeetingOrganiser: true,
          isAdmin: false,
        });
      } else {
        setEmployeeData({
          ...employeeData,
          isMeetingOrganiser: false,
        });
      }
    } else if (name === "isAdmin" && type === "checkbox") {
      if (checked) {
        setEmployeeData({
          ...employeeData,
          isMeetingOrganiser: false,
          isAdmin: true,
        });
      } else {
        setEmployeeData({
          ...employeeData,
          isAdmin: false,
        });
      }
    } else {
      setEmployeeData({
        ...employeeData,
        [name]: updatedValue,
      });
    }

    setFormValues({
      ...formValues,
      [name]: updatedValue,
    });

    setEditEmployeeData({
      ...editEmployeeData,
      [name]: updatedValue,
    });

    // Reset errors for all fields
    setErrors({
      ...errors,
      [name]: "",
      empId: "",
      email: "",
      whatsAppNo: "",
      designationId: "",
      departmentId: "",
      unitId: "",
    });
  };

  const editHandleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setErrors({});

    if (type === "checkbox") {
      if (name === "editIsMeetingOrganiser" && checked) {
        setEditEmployeeData({
          ...employeeData,
          editIsMeetingOrganiser: true,
          editIsAdmin: false,
        });

        setEditIsMeetingOrganiser(true);
        setEditIsAdmin(false);
      } else if (name === "editIsAdmin" && checked) {
        setEditEmployeeData({
          ...employeeData,
          editIsMeetingOrganiser: false,
          editIsAdmin: true,
        });
        setEditIsMeetingOrganiser(false);
        setEditIsAdmin(true);
      } else if (!checked) {
        setEditEmployeeData({
          ...employeeData,
          editIsMeetingOrganiser: false,
          editIsAdmin: false,
        });
        setEditIsMeetingOrganiser(false);
        setEditIsAdmin(false);
      }
    } else {
      setEditEmployeeData({
        ...editEmployeeData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };

  const updateErrors = (field, message) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (message) {
        newErrors[field] = message;
      } else {
        delete newErrors[field];
      }
      return newErrors;
    });
  };

  const nameValidationCheck = () => {
    const excludeHtml = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;

    if (!employeeData.name.trim()) {
      updateErrors("name", "Employee Name is required");
    } else if (!excludeHtml.test(employeeData.name)) {
      updateErrors("name", constatntMessages.invalidInputContactPersonName);
    } else if (
      employeeData.name.trim().length < 2 ||
      employeeData.name.trim().length > 100
    ) {
      updateErrors("name", "Name must be  2 - 100  characters");
    } else {
      updateErrors("name", null);
    }
  };

  const emailValidationCheck = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!employeeData.email.trim()) {
      updateErrors("email", "Email is required");
    } else if (!emailRegex.test(employeeData.email)) {
      updateErrors("email", "Invalid email format");
    } else {
      updateErrors("email", null);
    }
  };

  const empIdValidationCheck = () => {
    const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;

    if (!employeeData.empId.trim()) {
      updateErrors("empId", "Employee ID is required");
    } else if (!excludeHtml.test(employeeData.empId)) {
      updateErrors("empId", constatntMessages.invalidInput);
    } else if (
      employeeData.empId.trim().length < 2 ||
      employeeData.empId.trim().length > 20
    ) {
      updateErrors("empId", "Employee ID must be  2 - 20  characters");
    } else {
      updateErrors("empId", null);
    }
  };

  // const whatsAppNoValidationCheck = () => {
  //   const newErrors = { ...errors };
  //   const phoneNumberRegex = /^[0-9]{10}$/;
  //   const whatsAppNo = formValues.whatsAppNo;

  //   if (whatsAppNo && !phoneNumberRegex.test(whatsAppNo)) {
  //     newErrors.whatsAppNo = "Phone Number must be 10 digits long";
  //   } else {
  //     delete newErrors.whatsAppNo;
  //   }

  //   setErrors(newErrors);
  //   return newErrors;
  // };
  //Create EMPLOYEE
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!isValidate()) {
      setIsLoading(false);
      return;
    }

    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const { designation, department, ...apiPayload } = employeeData;
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/employee/createEmployee`,
        apiPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            ip: await fetchIpAddress(),
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        setEmployeeData({
          name: "",
          empId: "",
          email: "",
          whatsAppNo: "",
          designation: "",
          department: "",
          designationId: "",
          departmentId: "",
          unitId: "",
          isMeetingOrganiser: false,
          isAdmin: false,
          organizationId: organizationId,
        });

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        fetchEmployeeData();
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (error) {
      if (handleApiError(error)) return;

      console.error("Error creating employee:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Fetch Employee
  const fetchEmployees = async (bodyData) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      setIsFetching(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        params: { limit, page, order },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/listEmployee`,
        bodyData,
        headerObject
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      const data = response.data.data || {};

      setEmployees(data.employeeData);
      setTotalCount(data.totalCount || 0);
    } catch (error) {
      if (handleApiError(error)) return;

      setLoading(false);
    } finally {
      setIsFetching(false);
    }
  };

  const handleEmployeeClick = () => {
    setIsEmployeeSelected(true);
    fetchEmployees({
      organizationId,
      isEmployee: true,
      searchKey: "", // or keep previous searchKey
    });
  };

  const handleGuestClick = () => {
    setIsEmployeeSelected(false);
    fetchEmployees({
      organizationId,
      isEmployee: false,
      searchKey: "",
    });
  };

  useEffect(() => {
    if (!authData?.isInValidUser) {
      fetchEmployeeData();
    }
  }, [
    searchKey,
    page,
    limit,
    order,
    authData?.isInValidUser,
    isEmployeeSelected,
  ]);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchKey(value);
    setPage(1);
    if (/[<>]/.test(value)) {
      setSearchError(constatntMessages.titleRegexError);
    } else {
      setSearchError("");
    }
  };

  // const fetchEmployeeData = async () => {
  //   const bodyData = searchKey
  //     ? { searchKey, organizationId }
  //     : { organizationId };
  //   if (!authData?.isInValidUser) {
  //     await fetchEmployees(bodyData);
  //   }
  // };

  const fetchEmployeeData = async () => {
    if (!authData?.isInValidUser) {
      const bodyData = searchKey
        ? { searchKey, organizationId, isEmployee: isEmployeeSelected }
        : { organizationId, isEmployee: isEmployeeSelected };
      await fetchEmployees(bodyData);
    }
  };

  const handleRowsPerPageChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const totalPage = Math.ceil(totalCount / limit);
  const maxOption = Math.ceil(totalCount / 5) * 5;

  const handleClearSearch = () => {
    setSearchKey("");
    setPage(1);
    fetchEmployeeData();
  };

  const handleDeleteConfirm = async () => {
    try {
      if (employeeToDelete) {
        await deleteEmployee(employeeToDelete?._id);
        setShowDeleteModal(false);
        setEmployeeToDelete(null);
      }
    } catch (error) {
      console.error("Error while deleting unit:", error);
    }
  };
  const deleteEmployee = async (employeeId) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/deleteEmployee/${employeeId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            ip: await fetchIpAddress(),
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        const totalRemainingItems = totalCount - 1;
        const maxPages = Math.ceil(totalRemainingItems / limit);
        if (page > maxPages) {
          setPage(page - 1);
        }
        fetchEmployeeData();
        return response.data;
      }
    } catch (error) {
      if (handleApiError(error)) return;

      console.error("Error deleting Employee:", error);
      throw error;
    }
  };

  //Update Employee

  useEffect(() => {
    setEmpId(employeeData.empId || "");
    setEmail(employeeData.email || "");
    setDesignationId(employeeData.designationId || "");
    setDepartmentId(employeeData.departmentId || "");
    setUnitId(employeeData.unitId || "");
    setEditIsAdmin(employeeData.isAdmin || false);
    setWhatsAppNo(employeeData.whatsAppNo || "");
    setEditIsMeetingOrganiser(employeeData.isMeetingOrganiser || false);
    setSelectedDesignation({
      label: designations.find((dep) => dep?._id === employeeData.designationId)
        ?.name,
      value: designations.find((dep) => dep?._id === employeeData.designationId)
        ?._id,
    });
    setSelectedDepartment({
      label: departments.find((dep) => dep?._id === employeeData.departmentId)
        ?.name,
      value: departments.find((dep) => dep?._id === employeeData.departmentId)
        ?._id,
    });
    SetSelectedUnit({
      label: units.find((dep) => dep?._id === employeeData.unitId)?.name,
      value: units.find((dep) => dep?._id === employeeData.unitId)?._id,
    });
  }, [employeeData, authData?.isInValidUser]);

  const updateNameValidationCheck = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z ,&,/-]+$/;
    const excludeHtmlForName = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!name.trim()) {
      errors.editName = "Employee Name is required";
    } else if (!excludeHtmlForName.test(name)) {
      errors.editName = constatntMessages.invalidInputContactPersonName;
    }
    setErrors(errors);
  };

  const updateEmailValidationCheck = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      errors.editEmail = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.editEmail = "Invalid email format";
    }
    setErrors(errors);
  };

  const updateEmpIdValidationCheck = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
    if (!empId.trim()) {
      errors.editEmpId = "Employee ID is required";
    } else if (!excludeHtml.test(empId)) {
      errors.editEmpId = constatntMessages.invalidInput;
    }
    setErrors(errors);
  };

  const updateCompanyNameValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(companyName)) {
      updateErrors("editCompanyName", constatntMessages.invalidInput);
    }
  };

  const updateRoleValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(role)) {
      updateErrors("editRole", constatntMessages.invalidInput);
    }
  };

  const updateDesignationValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(designation)) {
      updateErrors("editDesignation", constatntMessages.invalidInput);
    }
  };
  const updateDepartmentValidationCheck = () => {
    const excludeHtmlForName = /^[0-9a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!excludeHtmlForName.test(department)) {
      updateErrors("editDepartment", constatntMessages.invalidInput);
    }
  };

  const updateGuestNameValidationCheck = () => {
    const excludeHtml = /^[0-9a-zA-Z ,&,/-]+$/;
    const excludeHtmlForName = /^[a-zA-Z .,:;()/\-_@&$'"#]+$/;
    if (!name.trim()) {
      updateErrors("editName", "Guest Name is required");
    } else if (!excludeHtmlForName.test(name)) {
      updateErrors("editName", constatntMessages.invalidInputContactPersonName);
    }
  };

  const handleEditClick = (emp) => {
    setSelectedEmployee(emp);

    setIsConfirming(false);
    setName(emp.name);

    setEmpId(emp.empId);
    setEmail(emp.email);
    setDesignationId(emp.designationId);
    setDepartmentId(emp.departmentId);
    setWhatsAppNo(emp.whatsAppNo);
    setUnitId(emp.unitId);
    setShowEditModal(true);
    setIsMeetingOrganiser(emp.isMeetingOrganiser);
    setEditIsMeetingOrganiser(emp.isMeetingOrganiser);
    setIsAdmin(emp.setIsAdmin);
    setEditIsAdmin(emp.isAdmin);
    setSelectedOption([
      {
        label: emp?.designationDetails?.name,
        value: emp?.designationDetails?._id,
      },
    ]);
    setSelectedDepartmentOption([
      {
        label: emp?.departmentDetails?.name,
        value: emp?.departmentDetails?._id,
      },
    ]);
    setSelectedUnitOption([
      {
        label: emp?.unitDetails?.name,
        value: emp?.unitDetails?._id,
      },
    ]);
    setDepartment(emp.department);
    setDesignation(emp.designation);
    setCompanyName(emp.companyName);
    setRole(emp.role);
    setErrors(false);
  };

  const editIsValidate = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z -.(),-,_/]+$/;

    if (!name.trim()) {
      errors.editName = "Employee Name is required";
    } else if (!excludeHtml.test(name)) {
      errors.editName = constatntMessages.invalidInput;
    } else if (name.trim().length < 2 || name.trim().length > 100) {
      errors.editName = "Name must be  2 - 100  characters";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email.trim()) {
      errors.editEmail = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.editEmail = "Invalid email format";
    }

    if (!empId.trim()) {
      errors.editEmpId = "Employee ID is required";
    } else if (!excludeHtml.test(empId)) {
      errors.editEmpId = constatntMessages.invalidInput;
    }

    const whatsAppTrimmed = (whatsAppNo || "").toString().trim();
    if (whatsAppTrimmed) {
      const whatsappRegex = /^\d{10}$/;
      if (!whatsappRegex.test(whatsAppTrimmed)) {
        errors.editWhatsAppNo = constatntMessages.whatsAppNo;
      }
    }
    setErrors(errors);
    return errors;
  };

  const handleEditSave = async (e) => {
    const newErrors = editIsValidate();
    setIsEditLoading(true);
    if (Object.keys(newErrors).length === 0) {
      try {
        const updateEmployee = {
          name,
          empId,
          email,
          departmentId,
          whatsAppNo,
          designationId,
          unitId,
          organizationId,
          isAdmin: editIsAdmin,
          isMeetingOrganiser: true,
        };
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/V1/employee/editEmployee/${selectedEmployee?._id}`,
          updateEmployee,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setName("");
          setEmpId("");
          setEmail("");
          setDepartmentId("");
          setDesignationId("");
          setUnitId("");
          setEditIsMeetingOrganiser("");
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setSelectedEmployee(null);
          setShowEditModal(false);
          fetchEmployeeData();
          setShowEditModal(false);
          setErrors({ ...errors, editEmployeeData: "" });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowEditModal(true);
        }
      } catch (error) {
        if (handleApiError(error)) return;

        console.log("Error while updating Employee:", error);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const guestEditIsValidate = () => {
    const errors = {};
    const excludeHtml = /^[0-9a-zA-Z .(),\-_/]+$/;

    if (!name?.trim()) {
      errors.editName = "Guest Name is required";
    } else if (!excludeHtml.test(name)) {
      errors.editName = constatntMessages.invalidInput;
    } else if (name.trim().length < 2 || name.trim().length > 100) {
      errors.editName = "Name must be 2 - 100 characters";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email?.trim()) {
      errors.editEmail = "Email is required";
    } else if (!emailRegex.test(email)) {
      errors.editEmail = "Invalid email format";
    }

    if (department?.trim()) {
      if (!excludeHtml.test(department)) {
        errors.editDepartment = constatntMessages.invalidInput;
      } else if (
        department.trim().length < 2 ||
        department.trim().length > 100
      ) {
        errors.editDepartment = "Department Name must be 2 - 100 characters";
      }
    }

    if (designation?.trim()) {
      if (!excludeHtml.test(designation)) {
        errors.editDesignation = constatntMessages.invalidInput;
      } else if (
        designation.trim().length < 2 ||
        designation.trim().length > 100
      ) {
        errors.editDesignation = "Designation Name must be 2 - 100 characters";
      }
    }

    // Company name validation (optional)
    if (companyName?.trim()) {
      if (!excludeHtml.test(companyName)) {
        errors.editCompanyName = constatntMessages.invalidInput;
      } else if (
        companyName.trim().length < 2 ||
        companyName.trim().length > 100
      ) {
        errors.editCompanyName = "Company Name must be 2 - 100 characters";
      }
    }

    // Role validation (optional)
    if (role?.trim()) {
      if (!excludeHtml.test(role)) {
        errors.editRole = constatntMessages.invalidInput;
      } else if (role.trim().length < 2 || role.trim().length > 100) {
        errors.editRole = "Role must be 2 - 100 characters";
      }
    }

    // WhatsApp number validation (optional)
    const whatsAppTrimmed = (whatsAppNo || "").toString().trim();
    if (whatsAppTrimmed) {
      const whatsappRegex = /^\d{10}$/;
      if (!whatsappRegex.test(whatsAppTrimmed)) {
        errors.editWhatsAppNo = constatntMessages.whatsAppNo;
      }
    }

    setErrors(errors);
    return errors;
  };

  const handleEditSaveGuest = async (e) => {
    const newErrors = guestEditIsValidate();
    setIsEditLoading(true);
    if (Object.keys(newErrors).length === 0) {
      // alert("IN EDIT GUEST")
      try {
        const updateGuest = {
          name,
          email,
          department,
          whatsAppNo,
          designation,
          organizationId,
          companyName,
          role,
        };
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/V1/employee/editGuest/${selectedEmployee?._id}`,
          updateGuest,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setName("");
          setEmpId("");
          setEmail("");
          setDepartmentId("");
          setDesignationId("");
          setUnitId("");
          setEditIsMeetingOrganiser("");
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setSelectedEmployee(null);
          setShowEditModal(false);
          fetchEmployeeData();
          setShowEditModal(false);
          setErrors({ ...errors, editEmployeeData: "" });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowEditModal(true);
        }
      } catch (error) {
        if (handleApiError(error)) return;

        console.log("Error while updating Employee:", error);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const [isConfirming, setIsConfirming] = useState(false);

  const handleSaveClick = () => {
    const newErrors = editIsValidate();
    if (Object.keys(newErrors).length === 0) {
      setIsConfirming(true);
    } else {
      setShowEditModal(true);
      setIsConfirming(false);
    }
  };

  const handleSaveClickGuest = () => {
    const newErrors = guestEditIsValidate();
    if (Object.keys(newErrors).length === 0) {
      setIsConfirming(true);
    } else {
      setShowEditModal(true);
      setIsConfirming(false);
    }
  };

  const handleConfirmSave = () => {
    handleEditSave();
    setShowEditModal(false);
    setIsConfirming(false);
  };
  const handleConfirmSaveGuest = () => {
    handleEditSaveGuest();
    setShowEditModal(false);
    setIsConfirming(false);
  };
  const handleCancel = () => {
    setIsConfirming(false);
  };
  const handleClose = () => {
    setShowEditModal(false);
    setIsConfirming(false);
  };

  const handleToggle = (empId, newStatus) => {
    setEmployees((prevEmployees) =>
      prevEmployees.map((employee) =>
        employee?._id === empId
          ? { ...employee, isActive: newStatus }
          : employee
      )
    );
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  //View Single Employee Details
  const handleViewClick = async (employee) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/viewSingleEmployee/${employee?._id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      setViewEmployee(response.data.data);

      setShowViewModal(true);
    } catch (error) {
      console.error("Error fetching single employee details", error);
      if (handleApiError(error)) return;
    }
  };

  const fileInputRef = useRef(null);
  const handleFileChange = (event) => {
    const selectedFile = event.target.files?.[0];

    if (!selectedFile) {
      if (!file) {
        setUploadError("No file selected. Please choose a file.");
      }
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);
        setFile(selectedFile);
        setFileName(selectedFile.name);
        setUploadError("");
      } catch (error) {
        setUploadError("Error processing the file. Ensure it's valid.");
        console.error(error);
      }
    };

    reader.onerror = () => {
      setUploadError("Error reading the file.");
      console.error(reader.error);
    };

    reader.readAsArrayBuffer(selectedFile);
  };
  const handleBack = () => {
    setCamefrompreviospage(false);
    navigate(-1);
  };

  const handleFileUpload = async () => {
    if (!file) {
      setUploadError("No file selected. Please choose a file to upload.");
      setFileHintsMessage("");
      setTimeout(() => {
        setUploadError("");
        setFileHintsMessage(constatntMessages.fileHints);
      }, 4000);
      return;
    } else {
      setFile(null);
      setFileHintsMessage(constatntMessages.fileHints);
      fileInputRef.current.value = null;
    }

    const formData = new FormData();
    formData.append("file", file);
    try {
      setIsUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/import-employee-by-rabitmq/${organizationId}`,
        formData,
        {
          headers: {
            Authorization: accessToken,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        setFile(null);
        setFileName("");
        setUploadCompleted(true);
        fetchEmployeeData();
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setTimeout(() => setResponseMessage(""), 6000);
      } else {
        fetchEmployeeData();
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }

      if (response.data.errorFileUrl) {
        const fileUrl = `${process.env.REACT_APP_API_URL}${response.data.errorFileUrl}`;
        await downloadErrorFile(fileUrl);
        setFileName("");
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        "Error during file upload.";
      setUploadError(errorMessage);
      setTimeout(() => setUploadError(""), 6000);
      console.error("Error during file upload:", errorMessage);
    } finally {
      setIsUploading(false);
    }
  };

  const downloadErrorFile = async (fileUrl) => {
    try {
      const link = document.createElement("a");
      link.href = fileUrl;

      const fileName = fileUrl.split("/").pop() || "error_report.xlsx";
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      setTimeout(async () => {
        try {
          const body = { fileName: fileName };
          const res = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/V1/employee/deleteErrorFile`,
            body,
            {
              headers: {
                Authorization: accessToken,
              },
            }
          );
          if (res.data.error) {
            toast.error(res.data.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        } catch (error) {
          if (!window.navigator.onLine) {
            toast.error(constatntMessages.noInternetErrorMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(constatntMessages.serverErrorMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        }
        document.body.removeChild(link);
      }, 1000);
    } catch (error) {
      console.error("Error triggering file download:", error);
    }
  };

  const printMasterData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/employee/sampleDataXLSX/${organizationId}`,
        {},
        {
          headers: {
            Authorization: accessToken,
          },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "SampleData.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("File downloaded successfully!", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } catch (error) {
      if (!window.navigator.onLine) {
        toast.error(constatntMessages.noInternetErrorMessage, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error(constatntMessages.serverErrorMessage, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFileName("");
    setUploadError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDeleteClick = (emp) => {
    setEmployeeToDelete(emp);
    setErrors(false);
    setShowDeleteModal(true);
  };

  return (
    <div>
      {!accessToken ? <Navigate to="/login" /> : null}

      <div className="main-content">
        <div className="Action-list-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Add Employee</h4>
            <div>
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>
          <div className="mt-2 table-box responsive-table">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Employee Name<span className="star-mark"> *</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Employee"
                      name="name"
                      value={employeeData.name}
                      onChange={handleChange}
                      onBlur={nameValidationCheck}
                    />
                    {errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Employee ID<span className="star-mark"> *</span>
                    </label>
                    <input
                      name="empId"
                      value={employeeData.empId}
                      onChange={handleChange}
                      type="text"
                      placeholder="Enter Employee ID"
                      onBlur={empIdValidationCheck}
                    />
                    {errors.empId && (
                      <span className="error-message">{errors.empId}</span>
                    )}
                  </div>
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">
                      Email<span className="star-mark"> *</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Enter Email"
                      name="email"
                      value={employeeData.email}
                      onChange={handleChange}
                      onBlur={emailValidationCheck}
                    />{" "}
                    {errors.email && (
                      <span className="error-message">{errors.email}</span>
                    )}
                  </div>
                </div>

                <DesignationDropdown
                  designations={designations}
                  employeeData={employeeData}
                  handleChange={handleChange}
                  errors={errors}
                />

                <DepartmentDropdown
                  departments={departments}
                  employeeData={employeeData}
                  handleChange={handleChange}
                  errors={errors}
                />

                <div className="col-md-4 col-sm-6">
                  {" "}
                  <UnitDropdown
                    units={units}
                    employeeData={employeeData}
                    handleChange={handleChange}
                    errors={errors}
                  />
                </div>
                <div className="col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="mb-1">WhatsApp Number</label>

                    <input
                      type="number"
                      name="whatsAppNo"
                      onChange={handleChange}
                      value={employeeData?.whatsAppNo}
                      // onBlur={whatsAppNoValidationCheck}
                      autoComplete="off"
                      placeholder="Enter WhatsApp Number"
                      onKeyDown={handleKeyDown}
                    />
                    {errors?.whatsAppNo && (
                      <span className="error-message">{errors.whatsAppNo}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="meeting-organiser d-flex align-items-center form-group">
                <input
                  type="checkbox"
                  name="isAdmin"
                  checked={employeeData.isAdmin}
                  onChange={handleChange}
                />
                <span>Set as Admin</span>
              </div>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  className="create-meeting-button Mom-btn"
                  disabled={isLoading}
                >
                  <p>Submit</p>
                </button>
              )}
            </form>

            <div className="row mt-4">
              <div className="col-xl-6">
                <div className="import-button-section d-flex align-items-center">
                  <div className="file file--upload form-group mb-0">
                    <label
                      htmlFor="input-file"
                      className="complaint-label-text height-input"
                    >
                      <img src={upload} className="material-icons"></img>
                      Import Employee Data
                    </label>
                    <input
                      id="input-file"
                      type="file"
                      accept=".csv, .xlsx"
                      ref={fileInputRef}
                      aria-label="Upload"
                      className="ng-untouched ng-pristine ng-valid"
                      style={{ display: "none" }}
                      onChange={(event) => handleFileChange(event)}
                    />

                    {fileName ? (
                      <p
                        className="emp-import-data d-flex align-items-center"
                        style={{
                          marginTop: "10px",
                          color: "#333",
                          fontSize: "12px",
                          gap: "6px",
                        }}
                      >
                        <span
                          onClick={handleRemoveFile}
                          style={{
                            cursor: "pointer",
                            color: "#dc3545",
                            fontWeight: "bold",
                            fontSize: "14px",
                          }}
                          title="Remove file"
                        >
                          ❌
                        </span>
                        Selected file: {fileName}
                      </p>
                    ) : (
                      // <p
                      //   className="emp-import-data import-emp"
                      //   style={{
                      //     marginTop: "10px",
                      //     color: "gray",
                      //     fontSize: "12px",
                      //   }}
                      // >
                      //   {fileHintsMessage ? (
                      //     <span>{fileHintsMessage}</span>
                      //   ) : null}
                      //   {uploadError && (
                      //     <span className="error-message">{uploadError}</span>
                      //   )}
                      // </p>
                      <p
  className="emp-import-data import-emp"
  style={{
    marginTop: "10px",
    color: "gray",
    fontSize: "12px",
  }}
>
  {fileHintsMessage ? (
    <span dangerouslySetInnerHTML={{ __html: fileHintsMessage }}></span>
  ) : null}
  {uploadError && (
    <span className="error-message">{uploadError}</span>
  )}
</p>

                    )}
                    {responseMessage && (
                      <p style={{ color: "green", marginTop: "10px" }}>
                        {responseMessage}
                      </p>
                    )}

                    <button
                      onClick={handleFileUpload}
                      disabled={isUploading}
                      className="create-meeting-button Mom-btn d-flex align-items-center emp-upload-btn"
                    >
                      <p>{isUploading ? "Uploading..." : "Upload"}</p>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="download-sample-section resp-mt-2-employee">
                  <button className="download-sample" onClick={printMasterData}>
                    <img
                      src={download}
                      className="material-icons"
                      alt="Download Icon"
                    />
                    <p>Download The Sample XLSX File</p>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="meeting-header-text line-height-h4 mt-4">
            <h4 className="mt-2">Manage Employees</h4>
          </div>

          <div className="mt-2 table-box responsive-table">
            <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">
              <div className="tbl-text-search resp-unit-search w-100 mb-2">
                <div className="left-tbl-text text-mb-3">
                  {totalCount > 0 ? (
                    <p>
                      Showing {(page - 1) * limit + 1} to{" "}
                      {Math.min(page * limit, totalCount)} of {totalCount}{" "}
                      Employee(s)
                    </p>
                  ) : null}
                </div>
                <div>
                  <div className="search-box position-relative unit-search">
                    <input
                      type="search"
                      autoComplete="off"
                      // placeholder="Search By Employee"
                      placeholder={
                        isEmployeeSelected
                          ? "Search By Employee"
                          : "Search By Guest"
                      }
                      value={searchKey}
                      onChange={handleSearch}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#4F2CC8"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                    {searchError && (
                      <span className="error-message">{searchError}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="graph-btn d-flex align-items-center">
              <button
                onClick={() => {
                  setIsEmployeeSelected(true);
                  setPage(1);
                }}
                className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${
                  isEmployeeSelected ? "newbtn-color" : "disable-btn"
                }`}
              >
                Employee(s)
              </button>

              <button
                onClick={() => {
                  setIsEmployeeSelected(false);
                  setPage(1);
                }}
                className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${
                  !isEmployeeSelected ? "newbtn-color" : "disable-btn"
                }`}
              >
                Guest(s)
              </button>
            </div>
            {/* <div className="graph-btn d-flex align-items-center">
              <button
                onClick={() => {
                  setIsEmployeeSelected(true);
                  fetchEmployeeData();
                }}
                className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${isEmployeeSelected ? "newbtn-color" : "disable-btn"
                  }`}
              >
                Employee(s)
              </button>

              <button
                onClick={() => {
                  setIsEmployeeSelected(false);
                  fetchEmployeeData();
                }}
                className={`badge bg-opacity-10 me-2 all-btn padding-btnall ${!isEmployeeSelected ? "newbtn-color" : "disable-btn"
                  }`}
              >
                Guest(s)
              </button>
            </div> */}

            {isFetching ? (
              <div className="tbl-text-search">
                <div className="meeting-page loader-cont">
                  <Loader />
                </div>
              </div>
            ) : employees?.length > 0 ? (
              <>
                <table className="mt-2 table table-bordered table-striped unit-table">
                  <thead>
                    <tr>
                      <th
                        className="text-align-center"
                        style={{ width: "50px" }}
                      >
                        Sl. No.
                      </th>
                      {isEmployeeSelected ? (
                        <th style={{ width: "300px" }}>Employee Name</th>
                      ) : (
                        <th style={{ width: "300px" }}>Guest Name</th>
                      )}

                      {isEmployeeSelected && (
                        <th
                          style={{ width: "120px" }}
                          className="text-align-center"
                        >
                          Employee ID
                        </th>
                      )}
                      <th
                        style={{ width: "10px" }}
                        className="text-align-center"
                      >
                        Updated At
                      </th>
                      {isEmployeeSelected && (
                        <th
                          style={{ width: "10px" }}
                          className="text-align-center"
                        >
                          Is Admin
                        </th>
                      )}
                      <th
                        style={{ width: "10px" }}
                        className="text-align-center"
                      >
                        Status
                      </th>

                      {screenSize <= 768 ? null : (
                        <th
                          scope="col"
                          className="action-col text-align-center"
                          style={{ width: "40px" }}
                        >
                          Action
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {employees.map((employee, index) => (
                      <tr key={employee?._id}>
                        {/* const serialNumber = index + 1 + (page - 1) * limit; */}
                        <td
                          data-label="Sl. No."
                          className="text-align-center blue-bold-text"
                          style={{ width: "50px" }}
                        >
                          {index + 1 + (page - 1) * limit}
                        </td>

                        <td
                          data-label="Employee Name"
                          className="word-break"
                          style={{ width: "300px" }}
                        >
                          {employee.isAdmin === true
                            ? employee.name + "(Admin)"
                            : employee.name}

                          {screenSize <= 768 ? (
                            <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp resp-innerdrp-1">
                              <Dropdown>
                                <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                  <Dropdown.Toggle id="dropdown-basic">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="#000"
                                      className="bi bi-three-dots-vertical"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                    </svg>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() => handleViewClick(employee)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="bi bi-eye me-2"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                      </svg>
                                      View
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() => handleEditClick(employee)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="me-2 bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                        />
                                      </svg>
                                      Edit
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </div>
                              </Dropdown>
                            </div>
                          ) : null}
                        </td>
                        {isEmployeeSelected && (
                          <td
                            data-label="Employee ID"
                            style={{ width: "120px" }}
                            className="text-align-center"
                          >
                            {employee.empId}
                          </td>
                        )}
                        <td
                          data-label="Updated At"
                          className="meeting-td-width-5 text-align-center"
                          style={{ width: "10px" }}
                        >
                          <p className="detail-date-time">
                            <span>{employee.formattedDate}</span>
                            <span className="text-secondary fs-12">
                              {employee.formattedTime}
                            </span>
                          </p>
                        </td>

                        {/* <td
                          data-label="Is Admin"
                          className="meeting-td-width-5 text-align-center"
                          style={{ width: "10px" }}
                        >
                          {employee.isAdmin ? "Yes" : "No"}
                        </td> */}
                        {isEmployeeSelected && (
                          <td
                            data-label="Is Admin"
                            className="meeting-td-width-5 text-align-center"
                            style={{ width: "10px" }}
                          >
                            {employee.isAdmin ? "Yes" : "No"}
                          </td>
                        )}
                        <td
                          data-label="Status"
                          className="meeting-td-width-5 metting-sts text-align-center"
                          style={{ width: "10px" }}
                        >
                          <CustomizedSwitches
                            key={employee._id}
                            employee={employee}
                            onToggle={() => {
                              fetchEmployeeData();
                            }}
                            disableCondition={userId == employee._id}
                          />
                        </td>
                        {screenSize <= 768 ? null : (
                          <td
                            data-label="Action"
                            className="text-align-center meeting-td-width-7"
                            style={{ width: "40px" }}
                          >
                            <Dropdown>
                              <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                <Dropdown.Toggle id="dropdown-basic">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#000"
                                    className="bi bi-three-dots-vertical"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                  </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => handleViewClick(employee)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="bi bi-eye me-2"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                    </svg>
                                    View
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => handleEditClick(employee)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="me-2 bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                      />
                                    </svg>
                                    Edit
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </div>
                            </Dropdown>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="tbl-bottom">
                  <div className="left-tbl-bottom">
                    {/* Left Arrow Button */}
                    {page !== 1 ? (
                      <button
                        className="left-arrow"
                        onClick={() => setPage(page > 1 ? page - 1 : 1)}
                        disabled={page === 1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-left"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                          />
                        </svg>
                      </button>
                    ) : null}

                    <Stack spacing={2}>
                      <Pagination
                        count={totalPage}
                        page={page}
                        siblingCount={0}
                        boundaryCount={2}
                        onChange={handlePageChange}
                        hidePrevButton
                        hideNextButton
                        sx={{
                          "& .Mui-selected": {
                            backgroundColor: "#388d27 !important",
                            color: "#fff !important",
                          },
                        }}
                      />
                    </Stack>

                    {page < totalPage ? (
                      <button
                        className="right-arrow"
                        onClick={() =>
                          setPage(page * limit < totalCount ? page + 1 : page)
                        }
                        disabled={page * limit >= totalCount}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                          />
                        </svg>
                      </button>
                    ) : null}
                  </div>

                  <div className="right-tbl-bottom">
                    <p>Rows Per Page</p>
                    <select
                      className="no-opt-box"
                      name="limit"
                      onChange={handleRowsPerPageChange}
                      value={limit}
                    >
                      {Array.from({ length: maxOption / 5 }).map((_, index) => {
                        const value = (index + 1) * 5;
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              <div className="no-data-img mt-3">
                <>
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                  <div className="button-outer">
                    <Button variant="primary" onClick={handleClearSearch}>
                      Clear
                    </Button>
                  </div>
                </>
              </div>
            )}
          </div>
          <Modal
            show={showViewModal}
            onHide={() => setShowViewModal(false)}
            backdrop="static"
          >
            <Modal.Header closeButton>
              {/* <Modal.Title>View Employee Details</Modal.Title> */}
              <Modal.Title>
                {isEmployeeSelected
                  ? "View Employee Details"
                  : "View Guest Details"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    {isEmployeeSelected ? (
                      <label className="mb-1">Employee Name</label>
                    ) : (
                      <label className="mb-1">Guest Name</label>
                    )}
                    <p>{viewEmployee?.name}</p>
                  </div>
                </div>
                {isEmployeeSelected && (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Employee ID</label>
                      <p>{viewEmployee?.empId}</p>
                    </div>
                  </div>
                )}

                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1">Email</label>
                    <p>{viewEmployee?.email}</p>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1">Designation </label>
                    <p>
                      {isEmployeeSelected
                        ? viewEmployee?.designationDetails?.name || "N/A"
                        : viewEmployee?.designation || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1">Department </label>

                    <p>
                      {isEmployeeSelected
                        ? viewEmployee?.departmentDetails?.name || "N/A"
                        : viewEmployee?.department || "N/A"}
                    </p>
                  </div>
                </div>

                {isEmployeeSelected && (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Unit</label>
                      <p>{viewEmployee?.unitDetails?.name}</p>
                    </div>
                  </div>
                )}
                {isEmployeeSelected && (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Admin </label>
                      <p>{viewEmployee?.isAdmin ? "Yes" : "No"}</p>
                    </div>
                  </div>
                )}
                {!isEmployeeSelected && (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Company Name</label>
                      <p>
                        {viewEmployee?.companyName
                          ? viewEmployee.companyName
                          : "N/A"}
                      </p>
                    </div>
                  </div>
                )}
                {!isEmployeeSelected && (
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    <div className="form-group">
                      <label className="mb-1">Role</label>
                      <p>{viewEmployee?.role ? viewEmployee.role : "N/A"}</p>
                    </div>
                  </div>
                )}
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1">WhatsApp No</label>
                    <p>
                      {viewEmployee?.whatsAppNo
                        ? viewEmployee?.whatsAppNo
                        : "N/A"}
                    </p>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1">Status </label>
                    <p>{viewEmployee?.isActive ? "Active" : "Deactive"}</p>
                  </div>
                </div>
              </div>
              {/* ------------------------------ */}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant=""
                className="add-minutes Mom-btn"
                onClick={() => setShowViewModal(false)}
              >
                <p> Close</p>
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            backdrop="static"
          >
            <Modal.Header closeButton>
              {/* <Modal.Title>Edit Employee</Modal.Title> */}
              <Modal.Title>
                {isEmployeeSelected ? "Edit Employee" : "Edit Guest"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isConfirming ? (
                isEmployeeSelected ? (
                  <p>Are you sure you want to update this Employee</p>
                ) : (
                  <p>Are you sure you want to update this Guest</p>
                )
              ) : (
                <Form className="employee-form edit-employee-section">
                  {isEmployeeSelected ? (
                    <Form.Group
                      controlId="designationName"
                      className="form-group"
                    >
                      <Form.Label className="mb-1">
                        Employee Name<span className="star-mark"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Employee Name"
                        value={name}
                        autoComplete="off"
                        onBlur={updateNameValidationCheck}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  ) : (
                    <Form.Group
                      controlId="designationName"
                      className="form-group"
                    >
                      <Form.Label className="mb-1">
                        Guest Name<span className="star-mark"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Guest Name"
                        value={name}
                        autoComplete="off"
                        onBlur={updateGuestNameValidationCheck}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Group>
                  )}
                  {errors?.editName && (
                    <span className="error-message">{errors?.editName}</span>
                  )}

                  {isEmployeeSelected && (
                    <Form.Group controlId="employeeId" className="form-group">
                      <Form.Label className="mb-1">
                        Employee ID<span className="star-mark"> *</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Employee ID"
                        value={empId}
                        autoComplete="off"
                        onBlur={updateEmpIdValidationCheck}
                        onChange={(e) => setEmpId(e.target.value)}
                      />
                    </Form.Group>
                  )}
                  {errors?.editEmpId && (
                    <span className="error-message">{errors?.editEmpId}</span>
                  )}

                  <Form.Group controlId="email" className="form-group">
                    <Form.Label className="mb-1">
                      Email<span className="star-mark"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Email"
                      value={email}
                      autoComplete="off"
                      onBlur={updateEmailValidationCheck}
                      onChange={(e) => setEmail(e.target.value.toLowerCase())}
                      readOnly
                    />
                  </Form.Group>
                  {errors?.editEmail && (
                    <span className="error-message">{errors?.editEmail}</span>
                  )}
                  {isEmployeeSelected ? (
                    <EditDesignationDropdown
                      designations={designations}
                      selectedDesignationId={selectedOption}
                      handleChange={handleDesignationChange}
                      value={selectedOption}
                    />
                  ) : (
                    <Form.Group controlId="designation" className="form-group">
                      <Form.Label className="mb-1">Designation</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Designation"
                        value={designation}
                        autoComplete="off"
                        onBlur={updateDesignationValidationCheck}
                        onChange={(e) => setDesignation(e.target.value)}
                      />
                    </Form.Group>
                  )}
                  {errors?.editDesignation && (
                    <span className="error-message">
                      {errors?.editDesignation}
                    </span>
                  )}
                  {isEmployeeSelected ? (
                    <EditDepartmentDropdown
                      departments={departments}
                      selectedDepartmentId={selectedDepartmentOption}
                      handleChange={handleDepartmentChange}
                      value={selectedDepartmentOption}
                    />
                  ) : (
                    <>
                      {" "}
                      <Form.Group controlId="department" className="form-group">
                        <Form.Label className="mb-1">Department</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Department"
                          value={department}
                          autoComplete="off"
                          onBlur={updateDepartmentValidationCheck}
                          onChange={(e) => setDepartment(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  )}
                  {errors?.editDepartment && (
                    <span className="error-message">
                      {errors?.editDepartment}
                    </span>
                  )}
                  {isEmployeeSelected && (
                    <EditUnitDropdown
                      units={units}
                      selectedUnitId={selectedUnitOption}
                      handleChange={handleUnitChange}
                      value={selectedUnitOption}
                      errors={errors}
                    />
                  )}

                  {!isEmployeeSelected && (
                    <>
                      {" "}
                      <Form.Group
                        controlId="companyName"
                        className="form-group"
                      >
                        <Form.Label className="mb-1">Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Company Name"
                          value={companyName}
                          autoComplete="off"
                          onBlur={updateCompanyNameValidationCheck}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  )}
                  {errors?.editCompanyName && (
                    <span className="error-message">
                      {errors?.editCompanyName}
                    </span>
                  )}

                  {!isEmployeeSelected && (
                    <>
                      {" "}
                      <Form.Group controlId="role" className="form-group">
                        <Form.Label className="mb-1">Role</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Role"
                          value={role}
                          autoComplete="off"
                          onBlur={updateRoleValidationCheck}
                          onChange={(e) => setRole(e.target.value)}
                        />
                      </Form.Group>
                    </>
                  )}
                  {errors?.editRole && (
                    <span className="error-message">{errors?.editRole}</span>
                  )}

                  <Form.Group controlId="whatsAppNo" className="form-group">
                    <Form.Label className="mb-1">WhatsAppNo</Form.Label>
                    <Form.Control
                      type="number"
                      name="whatsAppNo"
                      placeholder="Enter WhatsApp Number"
                      value={whatsAppNo}
                      autoComplete="off"
                      // onBlur={updateEmailValidationCheck}
                      onChange={(e) => setWhatsAppNo(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Group>
                  {errors?.editWhatsAppNo && (
                    <span className="error-message">
                      {errors?.editWhatsAppNo}
                    </span>
                  )}

                  {selectedEmployee?._id?.toString() !==
                    employeeDatas?.userData?._id?.toString() &&
                    isEmployeeSelected && (
                      <div className="meeting-organiser d-flex align-items-center">
                        <input
                          type="checkbox"
                          name="editIsAdmin"
                          value={isAdmin}
                          checked={editIsAdmin ? true : false}
                          onChange={editHandleChange}
                        />
                        <span>Set as Admin</span>
                      </div>
                    )}
                </Form>
              )}
            </Modal.Body>

            {isEmployeeSelected ? (
              <Modal.Footer>
                {isConfirming ? (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={handleCancel}
                    >
                      <p>Cancel</p>
                    </Button>
                    <Button
                      variant=""
                      className="create-meeting-button Mom-btn"
                      onClick={handleConfirmSave}
                    >
                      <p>Confirm Update</p>
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      <p>Close</p>
                    </Button>
                    {isEditLoading ? (
                      <SmallLoaderButton />
                    ) : (
                      <Button
                        variant=""
                        className="create-meeting-button Mom-btn"
                        onClick={handleSaveClick}
                      >
                        <p>Save Changes</p>
                      </Button>
                    )}
                  </>
                )}
              </Modal.Footer>
            ) : (
              <Modal.Footer>
                {isConfirming ? (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={handleCancel}
                    >
                      <p>Cancel</p>
                    </Button>
                    <Button
                      variant=""
                      className="create-meeting-button Mom-btn"
                      onClick={handleConfirmSaveGuest}
                    >
                      <p>Confirm Update</p>
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant=""
                      className="add-minutes Mom-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      <p>Close</p>
                    </Button>
                    {isEditLoading ? (
                      <SmallLoaderButton />
                    ) : (
                      <Button
                        variant=""
                        className="create-meeting-button Mom-btn"
                        onClick={handleSaveClickGuest}
                      >
                        <p>Save Changes</p>
                      </Button>
                    )}
                  </>
                )}
              </Modal.Footer>
            )}
          </Modal>
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isEmployeeSelected
                ? "Are you sure you want to delete this Employee?"
                : "Are you sure you want to delete this Guest"}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant=""
                className="add-minutes Mom-btn"
                onClick={handleDeleteConfirm}
              >
                <p>Delete</p>
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Employee;
